export default {
    state: {
        data: { }
    },
    mutations: {
        ['checkout/setData'] (store, data) {
            try {
                store.data = { ...data };
            } catch (err) {
                console.error(err);
            }
        },
        // ['checkout/updateData'] (store, data) {
        //     try {
        //         store.data = { ...store.data, [data.name]: data.data };
        //     } catch (err) {
        //         console.error(err);
        //     }
        // },
        /**
         * Записуем данные в Object для дальнейшей отправки на сервер.
         * @param store
         * @param payload
         */
        ['checkout/setRequestData'] (store, payload) {
            try {
                let data = JSON.parse(JSON.stringify(store.data));

                const setData = (DataLink, payloadLink) => {
                    const { name, value } = payloadLink;

                    if (typeof value !== 'undefined') {
                        DataLink.vue.requestData[ name ] = value;
                    } else {
                        delete DataLink.vue.requestData[ name ];
                    }
                }

                switch (App.helpers.getType(payload)) {
                    case 'object':
                        setData(data, payload);
                        break;
                    case 'array':
                        payload.forEach(el => setData(data, el));
                        break;
                }

                store.data = data;

            } catch (err) {
                console.error(err);
            }
        },
        // ['checkout/changeCreditName'] (store, payload) {
        //     store.data = {
        //         ...store.data,
        //         creditName: payload,
        //     };
        // },
        // ['checkout/changePaySystem'] (store, { value }) {
        //     store.data.vue.paySystem.items = store.data.vue.paySystem.items.map(el => {
        //         return {
        //             ...el,
        //             CHECKED: el.ID == value ? 'Y': 'N'
        //         }
        //     });
        // }
        ['checkout/setCityData'] (store, data) {
            try {
                store.data = {
                    ...store.data,
                    deliveryData: {
                        ...store.data.deliveryData,
                        city: data,
                    }
                };
            } catch (err) {
                console.error(err);
            }
        },
    },
    actions: {
        /**
         * Собираем данные и делаем запрос на сервер при изменении данных
         *
         * @param getters
         * @param commit
         * @param data
         * @param payload
         * @return {Q.Promise<void>}
         */
        async ['checkout/setAjax'] ({ getters, commit, state: { data } }, payload) {
            try {
                commit('global/loaderStart');

                const { requestData, settings } = data?.vue;
                const { requestFields } = data.vue.settings;

                // формируем данные для multidimensional array

                let formData = {
                    order: {
                        ...requestData,
                        [settings.actionKey]: settings.actionSave,
                    },
                    [settings.actionKey]: settings.actionRefresh,
                };

                if ( payload ) {
                    formData.order[payload.name] = payload.value;
                }

                for(let key in requestFields) {
                    if (key === 'double') {
                        requestFields[key].forEach(el => formData[el] = formData.order[el]);
                    } else if (key === 'main') {
                        requestFields[key].forEach(el => {
                            formData[el] = formData.order[el];
                            delete formData.order[el];
                        })
                    }
                }

                // отправляем данные на сервер

                const response = await axios.post(settings.ajaxUrl, formData);

                commit('global/loaderStop');

                if (!response.data.error) {
                    commit('checkout/setData', response.data.order);
                } else {
                    throw `request error status ${ response.status }`;
                }
            } catch (err) {
                console.error(err);
            }
        },
        /**
         * Собираем данные и сохраняем заказ после ответа делаем редирект
         *
         * @param getters
         * @param commit
         * @param data
         * @param payload
         * @return {Q.Promise<void>}
         */
        async ['checkout/saveOrder'] ({ state: { data } }) {
            try {
                const { requestData, settings } = data?.vue;

                let formData = {
                    ...requestData,
                    [settings.actionKey]: settings.actionSave,
                };
                const response = await axios.post(settings.ajaxUrl, formData)

                if (response?.data?.order?.REDIRECT_URL) {
                    location.href = response.data.order.REDIRECT_URL;
                } else {
                    const errorTypes = response?.data?.order?.ERROR;
                    console.log(errorTypes);
                    // if (errorTypes) {
                    //     Object.values(errorTypes).forEach(errors => {
                    //         errors.forEach(err => {
                    //             Vue.notify({
                    //                 type: 'error',
                    //                 title: err,
                    //             });
                    //             console.error(err);
                    //         });
                    //     });
                    // }
                }
            } catch (err) {
                console.error(err);
            }
        },
        /** init IPost **/
        async ['checkout/initIPostDelivery'] ({ state: { data }, getters, commit, dispatch }) {
            try {
                const getIPostDelivery = getters['checkout/getIPostDelivery'];
                const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
                // if transition from IPost
                if (IPostFieldsString) {
                    const id = getIPostDelivery?.ID;
                    if (IPostFieldsString && id) {
                        commit('checkout/setRequestData', { name: data?.vue?.delivery?.inputName, value: id });
                        await dispatch('checkout/setAjax');
                        dispatch('checkout/fillIPostFields');
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        ['checkout/fillIPostFields'] ({ state: { data }, commit }) {
            try {
                const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
                if (IPostFieldsString) {
                    const IPostFields = JSON.parse(IPostFieldsString);
                    Object.values(data.vue.delivery.props)?.forEach(el => {
                        if (el.CODE in IPostFields) {
                            if (el.CODE === 'CITY') {
                                commit('checkout/setCityData', IPostFields[el.CODE]);
                                commit('checkout/setRequestData', { name: el.inputName, value: IPostFields[el.CODE]?.UF_NAME });
                            } else {
                                commit('checkout/setRequestData', { name: el.inputName, value: IPostFields[el.CODE] });
                            }
                        }
                    });
                }
            } catch (err) {
                console.error(err);
            }
        },
    },
    getters:{
        ['checkout/getNotAvailableProductsIn1C']: ({ data }) => {
            const products = data?.vue?.products;
            return products?.filter(el => !el.isAvailableIn1C);
        },
        /** delivery **/
        ['checkout/getIPostDelivery']:({ data }) => {
            try {
                if (data?.vue) return Object.values(data?.vue?.delivery?.items).find(el => el.NAME.includes('IPOST'));
            } catch (err) {
                console.error(err);
            }
        },
        // ['checkout/checkIfProductIsNotAvailable1C']: ({ data }) => id => {
        //     const products = data?.vue?.products;
        //
        //     return !!products?.find(el => {
        //         const productId = el?.offer?.id || el?.id;
        //         if (productId == id && !el.isAvailableIn1C) {
        //             return true;
        //         }
        //         return false;
        //     });
        // }
    }
}